<!--基于v-charts和echarts的图表切换-->
<template>
  <div class="chart">
    <ve-chart
      height="100%"
      :data="chartData"
      :settings="chartSettings"
      :extend="chartExtends"
      :loading="loading"
      :data-empty="data.length? false: true"
    />
  </div>
</template>
<script>
export default {
  props: {
    columns: Array,
    data: Array,
    setting: Object,
    extend: Object,
    unit: Array,
    format: String,
    loading: Boolean
  },
  data () {
    return {
      chartData: {
        columns: this.columns,
        rows: this.data
      }
    }
  },
  computed: {
    chartSettings () {
      const setting = this.setting || {}
      const o = {}
      Object.assign(o, setting)
      return o
    },
    chartExtends () {
      const _this = this
      /**
       * 此处配置参考echart的配置项
      */
      const extend = this.extend || {}
      const o = {
        grid: {
          top: 100,
          left: 50,
          right: 50
        },
        xAxis: {
          axisLabel: {
            formatter: (value) => {
              return _this.$parseTime(value, this.format)
            }
          }
        },
        legend: {
          top: 30
        },
        tooltip: {
          axisPointer: {
            type: 'line'
          },
          backgroundColor: '#05294D',
          formatter (params) {
            let html = ''
            html += _this.$parseTime(params[0].axisValue, _this.format)
            for (let i = 0; i < params.length; i++) {
              if (params[i].data[1] !== null) {
                html += `<div>
                        ${params[i].marker} 
                        ${params[i].seriesName}: ${(params[i].data.length ? params[i].data[1] : params[i].data) + _this.unit[i]}  
                    </div>`
              }
            }
            return html
          }
        },
        barMaxWidth: 30,
        yAxis: { name: this.unit, nameTextStyle: { fontSize: 16 }, position: 'left' }
      }
      Object.assign(o, extend)
      return o
    }
  },
  watch: {
    data: {
      handler: function (val) {
        this.chartData.rows = val
      },
      deep: true // 对象内部的属性监听，也叫深度监听
    },
    columns (val) {
      this.chartData.columns = val
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.v-charts-data-empty
  background-color: #1C2550
  color #1cc197
  font-size 16px
.chart
  height 100%
  width 100%
</style>
